export default __webpack_public_path__ + "static/media/Cc.2747d53d.wav";